<template>
  <div class="row">
    <!--  业务列表  -->
    <div class="flex xs12">
      <va-card title="业务列表">
        <div class="row align-center mb-1">
          <div class="flex md6 xs12 sm6">
            <va-input
              class="ma-0"
              :value="displayName"
              placeholder="search by nickname"
              @input="search"
              removable
            >
              <va-icon name="fa fa-search" slot="prepend"/>
            </va-input>
          </div>
          <div class="flex md3 xs12 sm6">
            <va-button class="mb-2" flat disabled color="danger">总计{{totalCount}}条结果</va-button>
          </div>
          <div class="flex md3 xs12 sm12">
            <div class="d-flex justify--end">
              <va-button color="info" small :to="{ name: 'saveBusiness' }">新增业务</va-button>
            </div>
          </div>
        </div>
        <va-data-table
          :fields="fields"
          :data="businesses"
          :loading="loading"
          :totalPages="totalPages"
          @page-selected="listBusiness"
          api-mode
        >
          <template slot="actions" slot-scope="props">
            <va-button flat small color="gray" icon="fa fa-eye"
              :to='{path:`updateBusiness/${props.rowData.id}`, query:{name: props.rowData.name}}'/>
            <va-button flat small color="gray" icon="fa fa-trash"
              @click="deleteModal = true;deleteName=props.rowData.name"/>
          </template>
        </va-data-table>
        <va-modal
          v-model="deleteModal"
          title="删除业务"
          okText="提交"
          position="center"
          message="请再次确认是否要删除？"
          @ok="confirmDelete"
        />

      </va-card>
    </div>
  </div>
</template>

<script>
import businessApi from '../../api/business'
import debounce from 'lodash/debounce'
import { formatTime } from '@/utils/common'
export default {
  data () {
    return {
      message: ['Required field'],
      // serviceId: 3,
      businesses: [],
      loading: true,
      deleteModal: false,
      pageNumber: 1,
      totalCount: 0,
      pageSize: 10,
      totalPages: 1,
      displayName: '',
      deleteName: '',
    }
  },
  computed: {
    fields () {
      return [
        {
          name: 'displayName',
          title: '业务类型',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'name',
          title: '业务代码',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'description',
          title: '业务描述',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'createTime',
          title: '创建时间',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:actions',
          title: '操作',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
      ]
    },
  },
  created () {
    this.listBusiness()
  },
  methods: {
    listBusiness (pageNumber = this.pageNumber) {
      this.loading = true
      const params = {
        pageNumber: pageNumber,
        pageSize: this.pageSize,
        displayName: this.displayName,
      }
      businessApi.listBusiness(params).then(response => {
        this.businesses = response.businesses
        this.businesses.forEach(x => {
          x.createTime = formatTime(x.createTime)
        })
        this.loading = false
        this.pageNumber = pageNumber
        this.totalPages = response.pages.totalPage
        this.totalCount = response.pages.totalCount
      }).catch(error => alert(error))
    },
    confirmDelete () {
      if (this.deleteName === '') return
      businessApi.deleteBusiness(this.deleteName).then(response => {
        if (response.success === true) {
          this.showToast('删除业务成功', {
            duration: 1000,
            icon: 'fa-check',
            position: 'top-center',
            fullWidth: false,
          })
          this.listBusiness()
        }
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    search: debounce(function (displayName) {
      this.displayName = displayName
      if (this.displayName === '') { this.displayName = null }
      this.listBusiness()
    }, 400),
  },
}

</script>
<style lang="scss">
.data-table-server-pagination---avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}
</style>
